@let vermitler = vermittlerCache.vermittler$ | async;
<div class="flex min-h-dvh flex-col">
  <ui-header
    title="KFZ-Versicherung berechnen"
    [vermitlerLogo]="vermitler?.logo"
    [showDefaultLogo]="
      vermittlerCache.vermittlerError() !== null || (!!vermitler && !vermitler.logo)
    "
    [brandExtra]="brandConfig()?.headerComponent"
    [brandSecondary]="brandConfig()?.headerSecondaryComponent"
    [showPoweredByCpit]="brandConfig()?.features?.showPoweredByCpit ?? true"
    [stepInfo]="stepInfo()"
    (logoClick)="navigateToStart()"
  />

  @if (funnelLogin.loggingOut()) {
    <div class="flex flex-1 flex-col items-center justify-center gap-4">
      <mat-spinner [diameter]="40" color="accent" />
      <div class="text-base">Du wirst abgemeldet …</div>
    </div>
  } @else if (vermitler) {
    <mat-sidenav-container class="bg-cp-gray-100 flex-1 py-12">
      <div class="page-container">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-container>

    @if (showNavigator()) {
      <div
        class="fixed right-0 left-0 z-40 flex justify-center pointer-events-none mb-3 md:mb-10"
        [style.bottom.px]="navigatorBottomPx()"
      >
        <ui-page-navigator class="pointer-events-auto w-full md:w-auto" />
      </div>
    }

    @if (brandConfig()?.footerComponent; as footerCmp) {
      <div #footerHost>
        <ng-container *ngComponentOutlet="footerCmp" />
      </div>
    }
  } @else if (vermittlerCache.vermittlerError(); as vermittlerError) {
    <div class="flex flex-1 flex-col mt-28 gap-12 px-4">
      <img class="mx-auto" src="assets/invalid-vermitler-token.svg" alt="Invalid token" />

      <div class="mx-auto flex max-w-xl flex-col gap-4 text-center">
        @if (
          vermittlerError === 'not-activated' &&
          (brandConfig()?.features?.showVermittlerActivationHint ?? true)
        ) {
          <div class="font-bold">Der Rechner ist noch nicht freigeschaltet.</div>
          <div>Bitte wenden Sie sich an Ihren Versicherungsvermittler.</div>
          <div class="italic">
            Für Vermittler: Bitte öffnen Sie einmalig den comparit Vergleichsrechner, um Ihren
            Zugang einzurichten.
          </div>
        } @else {
          <div class="font-bold">Der Rechner ist derzeit nicht erreichbar.</div>
          <div>Bitte versuchen Sie es später erneut.</div>
        }
      </div>
    </div>
  } @else {
    <div class="flex flex-1 flex-col items-center justify-center">
      <mat-spinner [diameter]="56" color="accent" />
    </div>
  }
</div>
